import { ReactElement, ReactNode } from 'react'

import { PopupWrapper } from 'components/app/popup'
import CellHeading from 'components/ui/cell/__heading'
import CellValue from 'components/ui/cell/__value'

import cn from 'classnames'

import walletLogo from 'images/account/wallet.svg'

import IconClose from 'images/icon-close-blue.svg'

import AlertTriangleIcon from './icons/alert-triangle.svg'

import PopupSubtitle from './components/__subtitle'
import PopupHeading from './components/__heading'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

export default function AccountPopup({
  onClose,
  handleNextStep,
  moveBack,
  heading,
  subtitle,
  message,
  amount,
  buttonText,
  children,
  button,
  outcome,
  containerClassname,
  isNotePopup,
  isInIncrease,
  subtitleClassname,
  headerClassname,
  closeButtonClassname,
}: {
  onClose: () => void
  handleNextStep?: () => void
  moveBack?: () => void
  heading: string
  subtitle?: string
  message?: string
  amount?: number | string
  buttonText?: string
  children: ReactNode
  button?: ReactNode
  outcome?: any
  containerClassname?: string
  isNotePopup?: boolean
  isInIncrease?: boolean
  subtitleClassname?: string
  headerClassname?: string
  closeButtonClassname?: string
}): ReactElement {
  const { t } = useTranslation()
  
  return (
    <PopupWrapper
      onClose={onClose}
      classNames={[styles.container, containerClassname, cn({ [styles.notePopup]: isNotePopup })]}
    >
      {isNotePopup ? (
        <div className={styles.noteHeading}>
          <img src={AlertTriangleIcon} alt="alert triangle icon" />
          <PopupHeading className={cn(styles.noteTitle, headerClassname)}>{heading}</PopupHeading>
        </div>
      ) : (
        <PopupHeading className={headerClassname}>{heading}</PopupHeading>
      )}
      {subtitle && (
        <PopupSubtitle
          className={cn(
            styles.container__subtitle,
            subtitleClassname,
            { [styles.container__subtitle_note]: isNotePopup },
            { [styles.container__subtitle_increase]: isInIncrease },
          )}
        >
          {subtitle}
        </PopupSubtitle>
      )}
      {children}
      {message && amount && outcome && (
        <div className={styles.comment}>
          {outcome.map((item) => (
            <>
              <CellHeading>{item.heading}</CellHeading>
              <CellValue>{item.value}</CellValue>
            </>
          ))}
        </div>
      )}
      <div className={styles.nav}>
        {moveBack && (
          <span className={styles.buttonText} onClick={moveBack}>{t('back')}</span>
        )}
        {button && (
          <button className={styles.button} onClick={handleNextStep}>
            <img src={walletLogo} alt="wallet" />
            <span className={styles.buttonText}>{buttonText}</span>
          </button>
        )}
      </div>
      <button className={cn(styles.btn, closeButtonClassname)} type="button" onClick={onClose}>
        <img src={IconClose} alt="close" />
      </button>
    </PopupWrapper>
  )
}
